import React__default from 'react';
import { getTextboxComponentBySkin } from './components/option-skins/index.mjs';
import { useTextboxOptions } from './hooks/use-textbox-options.mjs';

const TextboxOptions = (props) => {
    const { onChanged, skin, option, isDisabled } = props;
    const { handleProductChoiceChangedEvent, textboxMessage } = useTextboxOptions(option.unitOfMeasure ?? "", isDisabled, onChanged);
    const TextboxComponent = getTextboxComponentBySkin(skin ?? "standard");
    const textboxProps = {
        ...props,
        message: {
            type: textboxMessage?.isValid ? "info" : "error",
            text: textboxMessage?.message,
        },
        onChanged: (event) => {
            handleProductChoiceChangedEvent(event);
        },
    };
    return React__default.createElement(TextboxComponent, { ...textboxProps });
};

export { TextboxOptions };
//# sourceMappingURL=textbox-options.mjs.map
